import { MS_API_BACKEND_URL } from "../settings";
import { api } from "./api";

class PricingService {
  constructor() {
    this.url = MS_API_BACKEND_URL;
  }

  async getSuggestions(params, options = {}) {
    const { pageIndex, orderBy, orderDirection, ...rest } = params;
    const url = `${this.url}/api/price-elasticity/v1/pricing/suggestions/`;
    const request = {
      signal: options.signal,
      params: {
        latest_run: true,
        ...rest,
        ...(orderDirection ? { ordering: orderDirection } : {}),
        ...(options.allPages ? { page: 1, pageSize: 1000 } : {})
      }
    };
    const response = await api.get(url, request);
    if (!options.allPages) return response;

    // This column uses V5/equivalent prices calculated in the frontend. Load
    // the filtered set so that it can be ordered before selecting a page.
    const results = [...response.data.results];
    for (let page = 2; page <= response.data.totalPages; page += 1) {
      const next = await api.get(url, {
        ...request,
        params: { ...request.params, page }
      });
      results.push(...next.data.results);
    }
    return { ...response, data: { ...response.data, results } };
  }

  async getPlanilhaDoDia() {
    const url = `${this.url}/api/price-elasticity/v1/pricing/planilha-do-dia/`;
    return await api.get(url);
  }

  async setMarcacaoSubiu(productBaseId, ativo) {
    const url = `${this.url}/api/price-elasticity/v1/pricing/marcacoes-subiu/`;
    return await api.post(url, { productBaseId, ativo });
  }

  async calcSkuPrices(body) {
    const url = `${this.url}/api/price-elasticity/v1/pricing/sku-calc-prices/`;
    return await api.post(url, body);
  }

  getV4Suggestions(productBaseIds, catalogId, signal) {
    return api.get(
      `${this.url}/api/price-elasticity/v1/pricing-v4/pilot/suggestions/`,
      {
        params: {
          product_base_ids: productBaseIds.join(","),
          catalog_id: catalogId
        },
        signal,
        timeout: 15000
      }
    );
  }

  getV4Suggestion(productBaseId, catalogId, signal) {
    return api.get(
      `${this.url}/api/price-elasticity/v1/pricing-v4/pilot/suggestions/${productBaseId}/`,
      {
        params: { catalog_id: catalogId },
        signal,
        timeout: 15000
      }
    );
  }

  async simulateSkuPrices(body, options) {
    const url = `${this.url}/api/price-elasticity/v1/pricing/sku-calc-prices/simulate/`;
    return await api.post(url, body, options);
  }

  async markupSimulate(body) {
    const url = `${this.url}/api/price-elasticity/v1/pricing/suggestions/markup-simulate/`;
    return await api.post(url, body);
  }

  async getPromoSuggestions(params) {
    const { pageIndex, orderBy, orderDirection, ...rest } = params;
    const url = `${this.url}/api/price-elasticity/v1/pricing/promo-suggestions/`;
    return await api.get(url, {
      params: {
        latest_run: true,
        ...rest,
        ...(orderDirection ? { ordering: orderDirection } : {})
      }
    });
  }

  async bulkUpdatePromocoes(items) {
    const url = `${this.url}/api/price-elasticity/v1/pricing/promocoes/bulk/`;
    return await api.post(url, { items });
  }

  async bulkPublishPromocoes(items) {
    const url = `${this.url}/api/price-elasticity/v1/pricing/promocoes/bulk-publish/`;
    return await api.post(url, { items });
  }

  async syncPromotions(runId) {
    const url = `${this.url}/api/price-elasticity/v1/pricing/promocoes/sync-from-run/`;
    return await api.post(url, { run_id: runId });
  }
}

const pricingService = new PricingService();
export default pricingService;
